<template>
  <div>
    <div class="input-group">
      <form class="row" v-if="!formSent && !formLoading" @submit.prevent="send_form">
        <div class="col-8 p-0">
          <div v-if="domain == 'ro'" class="form-group pb-2">
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom h6"
                   style="border: 1px solid #dee2e6 !important" name="cnp" id="cnp" placeholder=" " required/>
            <label class="form-control-placeholder" v-if="foreignchecking == false" for="cnp">{{ __('CNP') }} ( <input
                type="checkbox" style="border: 1px solid #dee2e6 !important;margin-bottom: 3px" name="foreigncheck"
                id="foreigncheck" @change="foreign"/> {{ __('foreign_citizen') }}?)</label>
            <label class="form-control-placeholder" v-else for="cnp">{{ __('foreign-id') }} ( <input
                type="checkbox" style="border: 1px solid #dee2e6 !important;margin-bottom: 3px" name="foreigncheck"
                id="foreigncheck" @change="foreign"/> {{ __('foreign_citizen') }}?) </label>
          </div>
          <div v-else class="form-group pb-2">
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom h6"
                   style="border: 1px solid #dee2e6 !important" name="cnp" id="cnp" placeholder=" " required/>
            <label class="form-control-placeholder"  for="cnp">{{ __('CNP') }}</label>
          </div>
        </div>
        <div class="col-4 p-0">
          <div class="form-group col-12">
            <select id="selectLanguage" class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0">
              <option :value="v" v-for="(v, k) in availableLocales" :selected="user.language === v">{{ k }}</option>
            </select>
            <label class="form-control-placeholder ml-3" for="selectLanguage"> {{ __('select-language') }}</label>
          </div>
        </div>
        <div v-if="!user.phone_number" class="col-12 p-0">
          <div class="form-group mb-0">
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom h6"
                   style="border: 1px solid #dee2e6 !important" name="phone_number" id="phone_number" placeholder=" "
                   required/>
            <label class="form-control-placeholder" for="phone_number">{{ __('phone') }}</label>
          </div>
        </div>
        <!-- Upload documents block-->
        <div class="col-12 p-0">
          <div class="form-group" style="padding-bottom: 0 !important; margin-bottom: 0 !important;">
            <label for="upload"
                   class="cursor-pointer my-2 action_box action_box_full_width_mobile cursor-pointer text-center"
                   style="width: 100% !important; background: #343a40 !important;color:white">
              <span aria-hidden="true" class="upload-disclaimer text-uppercase h7">{{ __('add_documents') }}</span>
              <span> {{ __('add_documents-1') }}</span>
              <input type="file" multiple="multiple" ref="upload" @change="handleFileChanges" :accept="accept"
                     id="upload" style="display: none">
            </label>
          </div>
          <div v-if="!uploadedPhoto" class="form-group mb-0 text-center">
            <small> {{ __('add_documents-2') }}</small>
          </div>
        </div>
        <div class="items-left mb-6 mt-3" v-if="register.files.length">
          <div class="file-upload-container text-xs row" v-for="(file, index) in register.files" :key="index">
            <span class="text-left float-left upload-file-appraisal col-10"><strong
                class="pr-3">{{ __('file') }} {{ index + 1 }}:</strong> {{ file.name }}</span>
            <!-- <span class="text-xs">{{ file.size | formatSize }}</span> -->
            <button
                class="vertical-super float-left border-white ml-1 remove-file bg-dark text-white h8 h-100 rounded-cirlcle"
                type="button" @click.prevent="register.files.splice(index, 1)" style="width:20px;">x
            </button>
            <br/>
          </div>
        </div>
        <!-- End upload documents block !-->
        <div class="col-12">
          <div class="row mt-3 mb-4">
            <div class="col-md-6 col-sm-12 btn-succes-created" style="padding-left: 0rem;">
              <button type="submit" class="action_box action_box_full_width_mobile cursor-pointer"
                      :class="(locale === 'en') ? 'eng-success-btn':''"
                      style="width: 100% !important; background: #343a40 !important;color:white"> {{ __('full-login') }}
              </button>
            </div>
            <div class="col-md-6 col-sm-12 btn-succes-created" style="padding-right: 0rem;">
              <a :href="currentAuctions" class="action_box action_box_full_width_mobile cursor-pointer"
                 style="text-align: center;width: 100% !important; background: #fff !important;color:#343a40 ">
                {{ __('basic-login') }}
              </a>
            </div>
          </div>
        </div>
      </form>

      <div class="d-flex w-100 loader center-vertically my-5" v-if="formLoading">
        <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
             height="40px"
             viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="#000"
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
            </svg>
        <h5 class="h7 text-center text-muted my-4 px-3">{{ __('info-sending') }}</h5>
      </div>
      <div class="iziToast-wrapper-sell iziToast-responsive-container"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountCreated",
  data: function () {
    return {
      accept: "image/*,application/pdf",
      register: {
        files: [],
        phone: null,
        cnp: null,
      },
      hasMessage: false,
      hasError: false,
      appraisal_message: '',
      formSent: false,
      formLoading: false,
      locale: window.AG.locale,
      availableLocales: window.AG.availableLocales,
      uploadedPhoto: false,
      foreignchecking: false
    }
  },
  props: ["user", "domain"],
  computed: {
    current: function () {
      return window.AG.locale === 'ro' ? 'curente' : 'current';
    },
    auctions: function () {
      return window.AG.locale === 'ro' ? 'licitatii' : 'auctions';
    },
    currentAuctions: function () {
      return 'https://www.artmark.ro/' + window.AG.locale + '/' + this.auctions + '/' + this.current;
    }
  },
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    foreign: function (event) {
      if (event.target.checked) {
        this.foreignchecking = true;
      } else {
        this.foreignchecking = false;
      }
    },
    resetFileInput() {
      const input = this.$refs.upload;
      input.type = 'text';
      input.type = 'file';
    },
    handleFileChanges(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadedPhoto = true;
      for (var i = files.length - 1; i >= 0; i--) {
        let duplicate = false;
        this.register.files.forEach(function (element) {
          if (element.name === files[i].name) {
            duplicate = true;
          }
        });
        if (!duplicate) {
          if (files[i].size / 1000 / 1000 < 15) {
            this.register.files.push(files[i]);
          } else {
            window.showToast(this.__('document-limit-exceeded'), 'error', null, '.iziToast-wrapper-sell')
          }
        }
      }
    },
    send_form: function () {
      this.formLoading = true;
      let that = this;
      let data = new FormData();
      if ($('#cnp').val()) data.append('cnp', $('#cnp').val());
      if ($('#foreigncheck').is(':checked') || that.domain != 'ro') data.append('foreign', '1');
      if ($('#phone_number').val()) data.append('phone_number', $('#phone_number').val());
      data.append('userSelectedLanguage', $('#selectLanguage').val());

      for (var i = 0; i < this.register.files.length; i++) {
        data.append("files[" + i + "]", this.register.files[i])
      }

      axios.post('/api/update-account-info', data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
        window.showToast(response.data.message, 'success', null, '.iziToast-wrapper-sell');
        that.formSent = true;
        that.formLoading = false;
        let toReplace = window.location.href.split("/").pop();
        let redirect = window.location.href.replace(toReplace, "");
        window.location.href = redirect;
      }).catch((error) => {
        window.showToast(error.response.data.message, 'error', null, '.iziToast-wrapper-sell')
        that.formLoading = false;
      });
    }
  }

}
</script>
